import reducer from './reducer';
import * as authActions from './actions';

export interface AuthState {
  isAuth: boolean,
  roleScreen: any,
  roleScreenPath: string,
  roleScreenStatus: 'idle' | 'loading' | 'ready' | 'error',
  roleScreenRequestId: string,
}

export {
  authActions,
};

export default reducer;
